import React from 'react'
import StatusBadge from '@components/common/StatusBadge/StatusBadge.component'
import { AppointmentStatus } from '@dataTypes/appointment.type'
import type { AssistantSchedule } from '@dataTypes/aiAssist.type'
import { AppointmentStatusMap } from '@utils/appointment.util'

export const AssistantAppointmentList = ({
  schedule,
}: {
  schedule: AssistantSchedule
}): React.ReactElement => (
  <div className="ai-assist-schedule-list ai-assist-schedule-list--structured">
    {schedule.sections.map((section) => (
      <div key={section.heading}>
        <div className="ai-assist-schedule-heading">{section.heading}</div>
        {section.items.map((item, index) => {
          const status =
            item.statusCode != null
              ? AppointmentStatusMap[item.statusCode as AppointmentStatus]
              : undefined
          return (
            <div
              key={`${section.heading}-${item.start}-${item.patient}-${index}`}
              className="ai-assist-schedule-item ai-assist-schedule-item--row"
            >
              <div className="ai-assist-schedule-time">
                {item.date ? `${item.date} ` : ''}
                {item.start} – {item.end}
              </div>
              <div className="ai-assist-schedule-patient">{item.patient}</div>
              <div className="ai-assist-schedule-provider">{item.provider}</div>
              {item.type ? (
                <div className="ai-assist-schedule-type">{item.type}</div>
              ) : null}
              <div className="ai-assist-schedule-meta">
                <span className="ai-assist-schedule-room">
                  {item.room ?? ''}
                </span>
                {status ? <StatusBadge status={status} /> : null}
              </div>
            </div>
          )
        })}
      </div>
    ))}
    {schedule.truncated &&
    schedule.returned != null &&
    schedule.total_count != null ? (
      <div className="ai-assist-schedule-footer">
        Showing {schedule.returned} of {schedule.total_count}
      </div>
    ) : null}
  </div>
)
